import { AuditLogsApi, BillingCloseoutApi, BillingPeriodsApi, DocsApi, EquipmentParamOptionsApi, EquipmentParamsApi, EquipmentTypesApi, EventsApi, OrderCommercialsApi, OrderItemsApi, OrderPortaloosApi, OrderRolloffsApi, OrdersApi, ServiceLineListOptionsApi, ServiceLineListsApi, ServiceLinesApi, ServiceLocationsApi, SubscriptionsApi, TaskGroupsApi, TaskReferencesApi, TasksApi, WorkRequestsApi, } from '@wayste/operations-client';
class OperationsService {
    axiosInstance;
    billingCloseoutApi;
    serviceLinesApi;
    serviceLineListsApi;
    serviceLineListOptionsApi;
    equipmentTypesApi;
    equipmentParamsApi;
    equipmentParamOptionsApi;
    orderRolloffsApi;
    subscriptionsApi;
    ordersApi;
    orderCommercialsApi;
    orderPortaloosApi;
    orderItemsApi;
    billingPeriodsApi;
    serviceLocationsApi;
    docsApi;
    auditLogsApi;
    taskGroupsApi;
    tasksApi;
    taskReferencesApi;
    eventsApi;
    workRequestsApi;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.billingCloseoutApi = new BillingCloseoutApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLinesApi = new ServiceLinesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLineListsApi = new ServiceLineListsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLineListOptionsApi = new ServiceLineListOptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentTypesApi = new EquipmentTypesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentParamsApi = new EquipmentParamsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentParamOptionsApi = new EquipmentParamOptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderRolloffsApi = new OrderRolloffsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.subscriptionsApi = new SubscriptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.ordersApi = new OrdersApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderCommercialsApi = new OrderCommercialsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderPortaloosApi = new OrderPortaloosApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderItemsApi = new OrderItemsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.billingPeriodsApi = new BillingPeriodsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.docsApi = new DocsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLocationsApi = new ServiceLocationsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.auditLogsApi = new AuditLogsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.taskGroupsApi = new TaskGroupsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.tasksApi = new TasksApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.taskReferencesApi = new TaskReferencesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.eventsApi = new EventsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.workRequestsApi = new WorkRequestsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderRolloffsApi = new OrderRolloffsApi(undefined, undefined, this.axiosInstance.mainInstance);
    }
    adminPortal = {
        auditLogs: {
            query: async (params) => {
                const response = await this.auditLogsApi.operationsV1AuditLogsGet(params || {});
                return response.data;
            },
        },
        serviceLines: {
            list: async (options) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.serviceLinesApi.operationsV1ServiceLinesIdDelete(params);
            },
            lists: {
                create: async (params) => {
                    const response = await this.serviceLineListsApi.operationsV1ServiceLineListsPost(params);
                    return response.data;
                },
                update: async (params) => {
                    const response = await this.serviceLineListsApi.operationsV1ServiceLineListsIdPut(params);
                    return response.data;
                },
                delete: async (params) => {
                    await this.serviceLineListsApi.operationsV1ServiceLineListsIdDelete(params);
                },
                listOptions: {
                    create: async (params) => {
                        const response = await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsPost(params);
                        return response.data;
                    },
                    update: async (params) => {
                        const response = await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsIdPut(params);
                        return response.data;
                    },
                    delete: async (params) => {
                        await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsIdDelete(params);
                    },
                },
            },
        },
        equipmentTypes: {
            list: async (options) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.equipmentTypesApi.operationsV1EquipmentTypesIdDelete(params);
            },
            params: {
                create: async (params) => {
                    const response = await this.equipmentParamsApi.operationsV1EquipmentParamsPost(params);
                    return response.data;
                },
                update: async (params) => {
                    const response = await this.equipmentParamsApi.operationsV1EquipmentParamsIdPut(params);
                    return response.data;
                },
                delete: async (params) => {
                    await this.equipmentParamsApi.operationsV1EquipmentParamsIdDelete(params);
                },
                options: {
                    list: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsGet(params);
                        return response.data;
                    },
                    fetch: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdGet(params);
                        return response.data;
                    },
                    create: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsPost(params);
                        return response.data;
                    },
                    update: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdPut(params);
                        return response.data;
                    },
                    delete: async (params) => {
                        await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdDelete(params);
                    },
                },
            },
        },
        orderRolloffs: {
            list: async (options) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsGet(options ?? {});
                return response.data;
            },
            create: async (orderRo) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsPost({ orderrolloff: orderRo });
                return response.data;
            },
            search: async (query) => {
                const response = await this.axiosInstance.mainInstance.post('/operations/v1/order-rolloffs/search', query);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsIdGet({ id });
                return response.data;
            },
            fetchByOrderID: async (orderID) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsGet({ orderID });
                return response.data.results?.[0] ?? null;
            },
            update: async (params) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsIdPut(params);
                return response.data;
            },
            cancel: async (id, contactsToNotify) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/order-rolloffs/${id}/cancel`, {
                    contactsToNotify,
                });
                return response.data;
            },
            splitSwitch: async (id) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/order-rolloffs/${id}/split-switch`);
                return response.data;
            },
            /**
             * Create an order roll-off with server-side billing orchestration (charge-first).
             * The billing fields (lineItems, etc.) ride alongside the ord_ro fields on the same
             * flat POST /operations/v1/order-rolloffs body, modelled by OrderrolloffCreateOrderRoRequest.
             */
            createWithBilling: async (params) => {
                const response = await this.orderRolloffsApi.operationsV1OrderRolloffsPost({ orderrolloff: params });
                return response.data;
            },
        },
        workRequests: {
            list: async (options) => {
                const response = await this.workRequestsApi.operationsV1WorkRequestsGet(options ?? {});
                return response.data;
            },
            create: async (params) => {
                const response = await this.workRequestsApi.operationsV1WorkRequestsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.workRequestsApi.operationsV1WorkRequestsIdPut(params);
                return response.data;
            },
        },
        subscriptions: {
            list: async (options) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsPost(params);
                return response.data;
            },
            /**
             * Create a subscription with server-side billing orchestration (charge-first).
             * Sends AdminSubscriptionCreateRequest to POST /operations/v1/subscriptions —
             * the body is a flat merge of the subscription fields and the billing fields.
             * Uses the raw axios instance to bypass the generated client's typed body constraint.
             */
            createWithBilling: async (params) => {
                const { subscription, ...billingFields } = params;
                const response = await this.axiosInstance.mainInstance.post('/operations/v1/subscriptions', {
                    ...subscription,
                    ...billingFields,
                });
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsIdGet(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.subscriptionsApi.operationsV1SubscriptionsIdDelete(params);
            },
            rolloffSearch: async (query) => {
                const response = await this.axiosInstance.mainInstance.post('/operations/v1/subscriptions/rolloff-search', query);
                return response.data;
            },
            /**
             * List a customer's roll-off orders (paginated) — backs the wayste-dashboard
             * order tab and any other customer-scoped roll-off view. Returns subscription
             * stubs, one per ord_ro row, sorted created_at DESC. See
             */
            operationRollOffOrders: async (params) => {
                const response = await this.axiosInstance.mainInstance.get('/operations/v1/subscriptions/operation-roll-off-orders', { params });
                return response.data;
            },
        },
        orders: {
            /**
             * List orders. Uses HTTP GET with full query params so filters like `ids`
             * (comma-separated batch fetch) work without depending on the generated OpenAPI client.
             * Response is the raw enriched-order array (not paginated).
             */
            list: async (params) => {
                const response = await this.axiosInstance.mainInstance.get('/operations/v1/orders', {
                    params: params ?? {},
                });
                return response.data;
            },
            create: async (params) => {
                const response = await this.ordersApi.operationsV1OrdersPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.ordersApi.operationsV1OrdersIdPut(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.ordersApi.operationsV1OrdersIdGet(params);
                return response.data;
            },
        },
        orderCommercials: {
            create: async (params) => {
                const response = await this.orderCommercialsApi.operationsV1OrderCommercialsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderCommercialsApi.operationsV1OrderCommercialsIdPut(params);
                return response.data;
            },
        },
        orderPortaloos: {
            create: async (params) => {
                const response = await this.orderPortaloosApi.operationsV1OrderPortaloosPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderPortaloosApi.operationsV1OrderPortaloosIdPut(params);
                return response.data;
            },
        },
        orderItems: {
            create: async (params) => {
                const response = await this.orderItemsApi.operationsV1OrderItemsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderItemsApi.operationsV1OrderItemsIdPut(params);
                return response.data;
            },
        },
        billingPeriods: {
            list: async (options) => {
                const response = await this.billingPeriodsApi.operationsV1BillingPeriodsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.billingPeriodsApi.operationsV1BillingPeriodsIdGet(params);
                return response.data;
            },
        },
        serviceLocations: {
            list: async (options) => {
                const response = await this.serviceLocationsApi.operationsV1ServiceLocationsGet(options);
                return response.data;
            },
        },
        documents: {
            list: async (options) => {
                const response = await this.docsApi.operationsV1DocsGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.docsApi.operationsV1DocsPost(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.docsApi.operationsV1DocsIdGet(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.docsApi.operationsV1DocsIdPut(params);
                return response.data;
            },
            readDumpTicket: async (params) => {
                const response = await this.docsApi.operationsV1DocsIdReadDumpTicketPost(params);
                return response.data;
            },
            delete: async (params) => {
                await this.docsApi.operationsV1DocsIdDelete(params);
            },
        },
        taskGroups: {
            list: async (params) => {
                const response = await this.taskGroupsApi.operationsV1TaskGroupsGet(params || {});
                return response.data;
            },
            update: async (params) => {
                const response = await this.taskGroupsApi.operationsV1TaskGroupsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.taskGroupsApi.operationsV1TaskGroupsIdDelete(params);
            },
            createTasks: async (params) => {
                const response = await this.tasksApi.operationsV1TaskGroupsTaskCreationSubIDPost(params);
                return response.data;
            },
            retryFailedTask: async ({ subID, retryTaskID }) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/task-groups/task-creation/${subID}`, undefined, { params: { retryTaskID } });
                return response.data;
            },
        },
        tasks: {
            /**
             * List operations tasks. Uses HTTP GET with full query params so filters like `type`
             * work before the generated OpenAPI client adds them explicitly.
             */
            list: async (params) => {
                const response = await this.axiosInstance.mainInstance.get('/operations/v1/tasks', {
                    params: params ?? {},
                });
                return response.data;
            },
            update: async (params) => {
                const response = await this.tasksApi.operationsV1TasksIdPut(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.tasksApi.operationsV1TasksPost(params);
                return response.data;
            },
        },
        taskReferences: {
            create: async (params) => {
                const response = await this.taskReferencesApi.operationsV1TaskReferencesPost(params);
                return response.data;
            },
        },
        events: {
            list: async (params) => {
                const response = await this.eventsApi.operationsV1EventsGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.eventsApi.operationsV1EventsPost(params);
                return response.data;
            },
            createBulk: async (params) => {
                const response = await this.eventsApi.operationsV1EventsBulkPost(params);
                return response.data;
            },
        },
        billingCloseout: {
            list: async (options) => {
                const response = await this.axiosInstance.mainInstance.get('/operations/v1/billing-closeout', {
                    params: options ?? {},
                });
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.billingCloseoutApi.operationsV1BillingCloseoutIdGet(params);
                return response.data;
            },
            retry: async (params) => {
                const response = await this.billingCloseoutApi.operationsV1BillingCloseoutIdRetryPost(params);
                return response.data;
            },
            match: async (params) => {
                const response = await this.billingCloseoutApi.operationsV1BillingCloseoutIdMatchPut(params);
                return response.data;
            },
            clearMatch: async (params) => {
                const response = await this.billingCloseoutApi.operationsV1BillingCloseoutIdMatchDelete(params);
                return response.data;
            },
            markDone: async (params) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/billing-closeout/${params.id}/done`, params.body);
                return response.data;
            },
            topUpStatus: async () => {
                const response = await this.axiosInstance.mainInstance.get('/operations/v1/billing-closeout/top-up-status');
                return response.data;
            },
            topUp: async () => {
                const response = await this.axiosInstance.mainInstance.post('/operations/v1/billing-closeout/top-up');
                return response.data;
            },
            heartbeat: async (params) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/billing-closeout/${params.id}/heartbeat`);
                return response.data;
            },
            endPresence: async (params) => {
                const response = await this.axiosInstance.mainInstance.delete(`/operations/v1/billing-closeout/${params.id}/heartbeat`);
                return response.data;
            },
            ticketThread: async (params) => {
                const response = await this.axiosInstance.mainInstance.get(`/operations/v1/billing-closeout/${params.reviewId}/tickets/${params.ticketId}/comments`);
                return response.data;
            },
            setClassification: async (params) => {
                const response = await this.axiosInstance.mainInstance.put(`/operations/v1/billing-closeout/${params.id}/classification`, { classification: params.classification });
                return response.data;
            },
            setAIFeedback: async (params) => {
                const response = await this.axiosInstance.mainInstance.put(`/operations/v1/billing-closeout/${params.id}/ai-feedback`, { feedback: params.feedback });
                return response.data;
            },
            addSibling: async (params) => {
                const response = await this.axiosInstance.mainInstance.post(`/operations/v1/billing-closeout/${params.id}/add-sibling`);
                return response.data;
            },
        },
    };
    // Alias for wayste app to use the same adminPortal functionality
    get wayste() {
        return this.adminPortal;
    }
}
export default OperationsService;
//# sourceMappingURL=Operations.service.js.map